import { render, staticRenderFns } from "./MarketOrderMessageModal.vue?vue&type=template&id=f031aa8e&scoped=true&"
import script from "./MarketOrderMessageModal.vue?vue&type=script&lang=js&"
export * from "./MarketOrderMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./MarketOrderMessageModal.vue?vue&type=style&index=0&id=f031aa8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f031aa8e",
  null
  
)

export default component.exports